
/**
 * Modelo de las liquidaciones de la consulta
 *
 * @class Liquidaciones
 */
export class Liquidacion {
  idliq_liquidacion: number;
  fecha_recibo: Date;
  numero_recibo: number;
  valor_cancelado: number;
  codigo_convenio: string;
  cupon: string;
  idexpediente?: number;
}

/**
 * Modelo de la consulta de liquidaciones no pagas
 *
 * @export
 * @class LiquidacionNoPaga
 */
export class LiquidacionNoPaga {
  idliq_liquidacion: number;
  idexpediente: number;
  iddocumento: number;
  valor_pagar: number;
  key?: string;
}

/**
 * Modelo de la consulta del expediente desde liquidacion
 *
 * @export
 * @class ExpedienteLiquidacion
 */
export class ExpedienteLiquidacion {
  id: number;
  codigo: string;
  id_expediente_cita: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/liquidaciones.model.ts